import React, { useState, useMemo, useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material'
import "../css/receivefunds.css"
import { Scrollbars } from 'react-custom-scrollbars'
import {FirebaseContext} from "../../../context/firebase";


const useStyles = makeStyles((theme: Theme) => ({
  // your styles unchanged...
}))

interface Props {
  handleSelectAccountPopupClose: () => void
  setTransferActiveBeneficiary: React.Dispatch<React.SetStateAction<string>>
  checkAccountNumber: () => void
}

const SelectAccountPopup: React.FC<Props> = ({
  handleSelectAccountPopupClose,
}) => {
  const { data, error, refresh } = useContext(FirebaseContext);
  
  const classes = useStyles()
  const [search, setSearch] = useState('')

  const accountType = data.accountType
  const accountNumber = data.accountPatial
  const accountBalance = data.balance


  return (
    <div id="sidebar-wrapper-beneficiaries-popup5" className="sidebar-wrapper-receive-funds">
      <div className="sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable">
        <aside className="sidebar-receive-funds-beneficiaries">
          <div className="funds-beneficiaries-header">
            <h6 className="funds-ben-header-h6">Select Account</h6>
            <button type="button" className="btn-beneficiaries-funds close" onClick={handleSelectAccountPopupClose}>×</button>
          </div>

          <div className="funds-beneficiaries-body">
            <div style={{ margin: '1rem 0' }}>
              <div>
                {/* ✅ enabled input with search functionality */}
                <input
                  type="text"
                  name="funds-beneficiaries-search"
                  id="funds-beneficiaries-search"
                  className="funds-beneficiaries-search"
                  placeholder="Search beneficiary..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '3rem', height: '230px' }}>
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <Scrollbars
                    style={{ transform: 'translateZ(-100px)', height: '230px' }}
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                  >
                    <div id="bill-select-telecom-type-options" style={{ padding: '1rem 0', width: '100%' }}>
                          <div
                            typeof="button"
                            className="bills-dropdown-button-xxx"
                            onClick={handleSelectAccountPopupClose}
                            style={{ width: '100%', display: 'flex' }}
                          >
                            <div>
                              <div className="mint-row">
                                <div className="taylor">
                                  {accountType} - <h6 className="mb-0">{accountBalance}</h6>
                                  <p className="mb-0">{accountNumber}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                    </div>
                  </Scrollbars>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}

export default SelectAccountPopup;
